module.exports = __webpack_public_path__ + "static/media/sf_2700.79e281b8959b889bdf4e027feb45e0ba.png";